import { ApplicationRef, Injectable, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat } from 'rxjs';
import { first } from 'rxjs/operators';
import { TimeService } from '../time.service';

@Injectable({
  providedIn: 'root'
})
export class CheckForUpdateService {
  private timeService = inject(TimeService);


  constructor() {
    const appRef = inject(ApplicationRef);
    const updates = inject(SwUpdate);

    // Allow the app to stabilize first, before starting
    // polling for updates with `interval()`.
    console.log('CheckForUpdateService constructor');
    const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
    const everySixHours$ = this.timeService.getIntervalInH(6);
    const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);

    everySixHoursOnceAppIsStable$.subscribe(async () => {
      console.log('everySixHoursOnceAppIsStable');
      try {
        const updateFound = await updates.checkForUpdate();
        console.log(updateFound ? 'A new version is available.' : 'Already on the latest version.');
      } catch (err) {
        console.error('Failed to check for updates:', err);
      }
    });
  }
}
